module.exports = __webpack_public_path__ + "img/block02.25589611.webp";